import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";

import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import { GridView } from "components";
import ListHeader from "components/PantallaList/Header/ListHeader";

import { ProcesoManager } from "managers";
import { DEFAULT_PAGINATION_VALUES, DateHelper  } from "utils";

export default function ProcesoList({ showLoading, hideLoading }) {
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [list, setList] = useState([]);
  
  const history = useHistory();
  const { cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();

  const ESTATUS_LIST = [
    { value: "", label: "Todos" },
    { value: "R", label: "En Ejecución" },
    { value: "E", label: "Error" },
    { value: "F", label: "Finalizado" },
    { value: "P", label: "Pendiente" },
  ];

  useEffect(() => {
    buscar();
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where]);

  const buscar = () => {
    const whereWithPaginationValues = {
      ...where,
      ...pagination,
      FechaInicio: where.FechaInicio,
      FechaFin: where.FechaFin,
    };
    ProcesoManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        try {
            for (let proceso of res.Data) {
                proceso["FechaInicio"] = DateHelper.formatStringDate(
                    proceso["FechaInicio"]
                );
              proceso["FechaFin"] = DateHelper.formatStringDate(
                proceso["FechaFin"]
            );
            }
          } catch (err) {}
        setList(res.Data);
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const handleClick = () => {
    let urlBase = `/ProcesoEdit?`;
    history.push(urlBase);
  };

  return (
    <div>
      <div style={{ paddingRight: "6px" }}>
        <ListHeader titulo={"Procesos"} crearNuevo={handleClick}></ListHeader>
      </div>
      <>
        <GridView
          pagination={pagination}
          setPagination={setPagination}
          allowPaging={pagination.EsPaginable}
          pageSize={pagination.CantidadPorPagina}
          pageIndex={pagination.IndiceDePagina}
          lastPageNumber={pagination.PaginasTotal}
          dataSource={list}
          onPageIndexChanging={onPageIndexChanging}
          where={where}
          setWhere={setWhere}
          height="70vh"
        >
          <GridView.Column
          width="80px"
          showClearFilter={true}
          />
          <GridView.Column 
            headerText="Id" 
            dataField="IdSec" 
            sortExpression="IdSec" 
            width="75px"
          />
          <GridView.Column
            headerText="Nombre"
            dataField="Nombre"
            sortExpression="Nombre"
          />
          <GridView.Column
            headerText="Resultado"
            dataField="Resultado"
            sortExpression="Resultado"
          />
         <GridView.Column
          headerText="Fecha Inicio"
          dataField="FechaInicio"
          sortExpression="FechaInicio"
          hideFilters
          isDisabled
         />
         <GridView.Column
          headerText="Fecha Fin"
          dataField="FechaFin"
          sortExpression="FechaFin"
          hideFilters
          isDisabled
         />
          <GridView.Column
             headerText="Estatus"
             dataField="Estatus"
             sortExpression="Estatus"
             width="150px"
             bodyRenderer={(row) => {
               const estatusOption = ESTATUS_LIST.find(option => option.value === row.Estatus);
               return estatusOption ? estatusOption.label : row.Estatus;
             }}
             filterRenderer={() => {
               return (
                 <Select
                   className="react-select primary"
                   options={ESTATUS_LIST}
                   value={ESTATUS_LIST.filter(function (option) {
                     return (
                       option.value ===
                       (where.Estatus ? where.Estatus : ESTATUS_LIST[0].value)
                     );
                   })}
                   name="Estatus"
                   onChange={(e) =>
                     setWhere({
                       ...where,
                       Estatus: e.value,
                     })
                   }
                 />
               );
             }}
            />
        </GridView>
      </>
    </div>
  );
}
